export default __webpack_public_path__ + "static/media/seal-1.2a34c69c.png";